export const nativeGhlForm = {
  iframeId: "inline-bBCf5g8khUF0GM1jZbom",
  formId: "bBCf5g8khUF0GM1jZbom",
  formName: "Form 0",
  iframeUrl: "https://api.leadconnectorhq.com/widget/form/bBCf5g8khUF0GM1jZbom",
  embedScriptUrl: "https://link.msgsndr.com/js/form_embed.js",
  embedHeight: 588,
  desktopFrameHeight: 660,
  mobileFrameHeight: 1200,
  formAnchorId: "contact",
} as const;
